import { render, staticRenderFns } from "./StateColumn.vue?vue&type=template&id=2b4de34e&scoped=true&"
import script from "./StateColumn.vue?vue&type=script&lang=js&"
export * from "./StateColumn.vue?vue&type=script&lang=js&"
import style0 from "./StateColumn.vue?vue&type=style&index=0&id=2b4de34e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4de34e",
  null
  
)

export default component.exports